export const REFUND_TO_KEYS = {
  wallet: "wallet",
  cash: "cash",
  check: "check",
  default: "default",
};

export const PAYMENT_MODE_KEYS = {
  cc: "cc",
  wallet: "wallet",
  check: "check",
  careCredit: "care_credit",
  greenSky: "greensky",
  giftCard: "gift_card",
  instantBankPayment: "instant_bank_payment",
  affirm: "affirm",
};

export const formattedPaymentStatus = {
  draft: "Draft",
  paid: "Paid",
  canceled: "Void",
  "partial paid": "Partial Paid",
  refunded: "Refunded",
  partial_refunded: "Partial Refunded",
  pending: "Pending",
  pending_merge: "Pending Merge",
  paid_by_merge: "Paid by Merge",
  refunded_from_merge: "Refunded from Merge",
};
